<div class="h-100 content flex">
    <span class="warning">
        <img src="../../assets/warning.png" alt="warning" class="warning-logo">
    </span>
    <div class="flex gap-4">
        <div class="flex gap-2">
            <span class="title">Members-Only Access</span>
            <span class="sub-title">
                This application is only for use by active ASCO members.
                If you believe you have received this message
                in error, please reach out to <a class="contact">customerservice&#64;asco.org</a>
            </span>
            <span class="sub-title mt-4"> or </span>
        </div>
        <button class="loginBtn" (click)="navigateToHome()">
            Login using a different username
        </button>
    </div>
</div>